import moment from 'moment';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { UseControllerProps, useController } from 'react-hook-form';
import { FaCalendarAlt } from 'react-icons/fa';
import { DATE_HYPHEN_FORMAT } from 'utils';

export type DateRangeControlProps = UseControllerProps<any> & {
  placeholder: string;
  startFieldName: string;
  endFieldName: string;
  disabled?: boolean;
};

function DateRangeControl(props: DateRangeControlProps) {
  const { placeholder, startFieldName, endFieldName, disabled } = props;
  const {
    field: { value, onChange },
  } = useController(props);
  const CustomInput = React.forwardRef((props: any, ref: any) => {
    return (
      <div style={{ position: 'relative' }}>
        <FaCalendarAlt
          style={{ position: 'absolute', top: '8px', left: '10px' }}
          onClick={props.disabled ? undefined : props.onClick}
        />
        <input
          className="form-control"
          onClick={props.onClick}
          style={{ paddingLeft: '32px' }}
          value={props.value}
          onChange={props.onChange}
          readOnly
          disabled={props.disabled}
          placeholder={props.placeholder}
          type="text"
        />
      </div>
    );
  });

  const startDate = value[startFieldName] ? new Date(value[startFieldName]) : null;
  const endDate = value[endFieldName] ? new Date(value[endFieldName]) : null;

  return (
    <div>
      <ReactDatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy/MM/dd"
        onChange={(update) => {
          onChange({
            ...value,
            [startFieldName]: update[0] ? moment(update[0]).format(DATE_HYPHEN_FORMAT) : null,
            [endFieldName]: update[1] ? moment(update[1]).format(DATE_HYPHEN_FORMAT) : null,
          });
        }}
        placeholderText={placeholder}
        isClearable={true}
        disabled={disabled}
        customInput={<CustomInput disabled={disabled} />}
      />
    </div>
  );
}

export default DateRangeControl;
